import React from "react";
import { PagingInfo } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";

const OmronPagingInfo = () => {
  const { t } = useTranslation();
  return (
    <PagingInfo
      view={({ totalResults }) => (
        <p className="u-font--s u-font--bold u-text--right u-mb0">
          {t("pagingInfo", { totalResults: totalResults })}
        </p>
      )}
    />
  );
};

export default OmronPagingInfo;
